module.exports = __webpack_public_path__ + "assets/img/Type BS (3).1ffac85b.jpg";